﻿// © Microsoft Corporation. All rights reserved.

// /**
//  * Provides common XSS escaping implementations.
//  * @returns {Escape}
//  */
// regex that looks for all the various dangerous HTML characters that we want to escape.
// every character in this match MUST have a corresponding map entry in sequenceValues,
// or it will be removed from the string we are escaping.
const sequenceTokens = /["&'/<>]/g;

// mapping object from the character we want to replace to the escape sequence for it.
// make sure that every character in the above regex is represented with an escape
// sequence in this object.
const sequenceValues = {
    "\"": "&quot;",
    "&": "&amp;",
    "'": "&#39;",
    "/": "&#47;",
    "<": "&lt;",
    ">": "&gt;"
};

export default {
    url: encodeURI,
    urlPart: encodeURIComponent,
    html: escapeHtml
};

/**
 * Encodes a text string as a valid Uniform Resource Identifier (URI)
 * @param {string} text - A value representing an encoded URI.
 * @return {string}
 */
function encodeURI(text) {
    // be sure to use a NON-STRICT comparison here so we get both null AND undefined.
    // will ALWAYS return a string; empty string if passed null or undefined.
    return (text != null && encodeURI(text)) || "";
}

/**
 * Encodes a text string as a valid component of a Uniform Resource Identifier (URI).
 * @param {string} text - A value representing an encoded URI component.
 * @returns {string}
 */
function encodeURIComponent(text) {
    // be sure to use a NON-STRICT comparison here so we get both null AND undefined.
    // will ALWAYS return a string; empty string if passed null or undefined.
    // @ts-ignore
    return (text != null && window.encodeURIComponent(text)) || "";
}

/**
 * Encodes a text string as a valid html, by mapping object from the character we want to replace to the escape sequence for it.
 * @param {string} text - The text
 * @returns {string}
 */
function escapeHtml(text) {
    // make sure text is a string (string concate with an empty string forces the type),
    // and then run a regex that finds all the characters we want to escape, and passes
    // each character to a function expression that looks up the appropriate replacement
    // sequence from an object map (key = character to replace, value = escaped sequence).
    // be sure to use a NON-STRICT comparison here so we get both null AND undefined.
    // will ALWAYS return a string; empty string if passed null or undefined.
    return (text != null && ("" + text).replace(sequenceTokens, function (ch) {
        return sequenceValues[ch] || "";
    })) || "";
}
